// Library Imports
import React, { useContext } from 'react'
import { Form } from 'react-bootstrap'
import { Skeleton } from '@mui/material'
import * as BiIcons from 'react-icons/bi'
// Context Imports
import { DirectoryContext } from '../../contexts/DirectoryContext'
// Asset Imports
import '../../assets/css/stylesheets/components/search/LocationDropDown.css'

function LocationDropDown({ selectedValue, onLocationChanged }) {

    // Get state option values from the context
    const {
        isStatesLoaded,
        isCountriesLoaded,
        stateOptions,
        countryOptions
    } = useContext(DirectoryContext);

    return (
        <>
            {
                !isStatesLoaded && !isCountriesLoaded ?
                    <Skeleton
                        sx={{ bgcolor: 'grey.200', opacity: '75%', borderRadius: '4%', margin: '1rem' }}
                        variant='rectangular'
                        animation="wave"
                        width={218}
                        height={45} />
                    :
                    <div className="locationdropdown">
                        <BiIcons.BiMap className='locationdropdown-icon' />
                        <Form.Select
                            className='locationdropdown-control'
                            id='locationDropDownControl'
                            value={selectedValue}
                            onChange={onLocationChanged}>
                            <option value=''>Select Location</option>
                            <option disabled value=''>States</option>
                            {
                                stateOptions?.map((state, index) => {
                                    return <option key={index} value={state.Name}>&nbsp;{state.Name}</option>
                                })
                            }
                            {/* <option disabled value=''>International</option>
                            {
                                countryOptions?.map((country, index) => {
                                    return <option key={index} value={country.UnCode}>&nbsp;{country.Name}</option>
                                })
                            } */}
                        </Form.Select>
                    </div>
            }
        </>
    )
}

export default LocationDropDown